/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { VoiceSessionCreateRequest } from '../../models/voice-session-create-request';
import { VoiceSessionCreateResponse } from '../../models/voice-session-create-response';

export interface CreateVoiceSession$Params {
  organizationSiteKey: KeyType;
      body?: VoiceSessionCreateRequest
}

export function createVoiceSession(http: HttpClient, rootUrl: string, params: CreateVoiceSession$Params, context?: HttpContext): Observable<StrictHttpResponse<VoiceSessionCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, createVoiceSession.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VoiceSessionCreateResponse>;
    })
  );
}

createVoiceSession.PATH = '/organization-sites/{organizationSiteKey}/voice-sessions';
